import { Map } from 'immutable';

import operationTypeFilterOptions from '../../constants/operationTypeFilterOptions';
import taxAuthorityFilterOptions from '../../constants/taxAuthorityFilterOptions';
import taxTypeFilterOptions from '../../constants/taxTypeFilterOptions';

export default Map({
  type: operationTypeFilterOptions[0],
  taxAuthority: taxAuthorityFilterOptions[0],
  taxType: taxTypeFilterOptions[0],
  adjustmentShow: false,
});
